<template>
  <div class="nav-btn-group">
    <a href="/owner/menu_coupons" class="btn btn-review-setting pl-5" v-if="permission.can('read', 'couponmaster')">設定
      <i class="fa fa-cog ml-5"></i>
    </a>
  </div>
</template>
<style scoped>
.nav-btn-group {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
</style>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import permissionService from "../../../services/permission_service";
  export default {
    data() {
      return {
        permission: permissionService
      }
    },
  }
</script>
